const link = {
  link1:
    "https://www.jedonneenligne.org/fdets/CLUBSDONSCIEN/?PersonalKey=1&FrmTrxType=Da%2FoFePL19ORosiL8yj7yA%3D%3D&FrmActUID4602=7k%2F2gfptO29%2BsQaCmkqTGg%3D%3D",
  link2:
    "https://www.jedonneenligne.org/fdets/CLUBSDONSCIEN/?PersonalKey=1&FrmTrxType=Da%2FoFePL19ORosiL8yj7yA%3D%3D&FrmActUID4602=7k%2F2gfptO29%2BsQaCmkqTGg%3D%3D"





};

export default link;
